<!--
 * @Function: 练习记录
-->

<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">

        <a-row :gutter="12" style="margin:0px 0px 16px 0px;">
          <a-col class="a-large-form" >
            <a-form-item label="" style="margin-bottom:0px;width:100%">
              <a-input placeholder="学员名称" v-model="queryParam.realname"></a-input>
            </a-form-item>
          </a-col>
          <a-col class="a-large-form" >
            <a-form-item label="" style="margin-bottom:0px;width:100%">
              <a-input placeholder="学员手机号" v-model="queryParam.phone"></a-input>
            </a-form-item>
          </a-col>

          <a-col class="a-small-form" >
            <a-form-item
              style="margin-bottom:0px;"
              label=""
              :required="false"
            >
            <a-select v-model="queryParam.testItemId" placeholder="请选择">
              <a-select-option v-for="(item,index) in itemList" :key="item.id" :value="item.id">{{ item.subjectName }}</a-select-option>
            </a-select>
              <!-- <j-dict-select-tag v-model="queryParam.subject" placeholder="科目" dictCode="subject" /> -->
            </a-form-item>
          </a-col>
          <a-col class="a-large-dbtime" >
            <a-form-item label="" style="margin-bottom:0px;width:100%">
              <a-range-picker
                :show-time="{ format: 'HH:mm' }"
                format="YYYY-MM-DD HH:mm"
               
                @change="dateChange"
                :placeholder="['交卷开始时间', '交卷结束时间']"
              />
            </a-form-item>
          </a-col>
          <a-button type="primary" @click="searchQuery" style="margin-left:15px;vertical-align: middle;">筛选</a-button>
          <a-button type="primary" @click="searchResetTest" style="margin-left:5px;vertical-align: middle;">重置</a-button>

          <a-button type="primary" @click="handleExportXls()" style="margin-left:5px;vertical-align: middle;">导出</a-button>
        </a-row>
      </a-form>
    </div>
    <div>
      <a-table
        ref="table"
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record" style="width:200px">
          <a @click="examPg(record.id)" v-if="record.status==1">有批改</a>
        </span>

      </a-table>
    </div>
    <pg-examModal ref="pgExamModal" @ok="modalFormOk"></pg-examModal>

  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getTestItemList } from '@/api/api'
  import PgExamModal from './PgExamModal'

  export default {
    name: 'TestRecordList',
    mixins: [JeecgListMixin],
    components: {
      PgExamModal
    },
    data () {
      return {
        description: 'ExerciseRecordList',
        sex: '0',
        examTime:"",
        queryParam: {
          examId:"",
          testItemId:undefined,
          realname: '',
          phone: '',
          commitTimeFrom:"",
          commitTimeTo:""
        },
        disableMixinCreated:true,
        // 表头
        columns: [

          {
            title: '考试编号',
            align: 'center',
            dataIndex: 'orgCode',
            width: 100,
            customRender: (text, row, index) => {
              return (<span >{index + 1}</span>)
            }
          },
          {
            title: '学员名称',
            align: 'center',
            dataIndex: 'realname',
            width: 100
          },
          {
            title: '学员手机号',
            align: 'center',
            dataIndex: 'phone',
            width: 120
          },
          // {
          //   title: '试卷类型',
          //   align: 'center',
          //   dataIndex: 'paperType_dictText',
          //   width: 100

          // },
          {
            title: '科目名称',
            align: 'center',
            dataIndex: 'paperName',
            width: 150

          },
          {
            title: '交卷时间',
            align: 'center',
            dataIndex: 'createTime',
            sorter: true,
            width: 200
          },
          {
            title: '总得分',
            align: 'center',
            dataIndex: 'getScore',
            sorter: true,
            width: 80,
             customRender: (text, row, index) => {
              return (<span >{row.getScore + row.teacherScore}</span>)
            }
          },
          {
            title: '耗时',
            align: 'center',
            dataIndex: 'useTime',
            width: 80

          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            scopedSlots: { customRender: 'action' },
            width: 260
          }
        ],
        itemList:[],
        dataSource: [],
        // 请求参数
        url: {
            list: '/exercise/elinkxExamPaperHistory/testList',
            // delete: '/userInfo/teacher/delete'
            // deleteBatch: "/course/elinkxCourse/deleteBatch",
            exportXlsUrl: "/exercise/elinkxExamPaperHistory/exportXls",
            // importExcelUrl: "course/elinkxCourse/importExcel",
          }
        }
      },
      computed: {
        importExcelUrl: function() {
          return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
        }
      },

    methods: {

      // 有批改
      examPg (historyId) {
        this.$refs.pgExamModal.open(historyId)
      },
      searchResetTest(){
        this.queryParam.testItemId = undefined;
        this.queryParam.realname = "";
        this.queryParam.phone = "";
        this.queryParam.commitTimeFrom = "";
        this.queryParam.commitTimeTo = "";
        this.loadData(1);
      },
      dateChange:function(data,data1){
      // console.log(data,data1)
      this.queryParam.commitTimeFrom = data1[0];
      this.queryParam.commitTimeTo = data1[1];
      },
      pgExamModalOk(){
        this.loadData();
      }
    },
    created () {
      this.queryParam.examId = this.$route.query.examId;
      this.loadData();
      getTestItemList({id:this.queryParam.examId}).then(res=>{
        if(res.success){
          this.itemList = res.result;
        }
      })
    }
    
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>

<style lang="scss" scoped >

</style>
